import { render, staticRenderFns } from "./TableAvailabilityContent.vue?vue&type=template&id=0a081d63&scoped=true&"
import script from "./TableAvailabilityContent.vue?vue&type=script&lang=js&"
export * from "./TableAvailabilityContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a081d63",
  null
  
)

export default component.exports